<script>
import { eventTimeRange, eventSessionTimeTitle, eventIsStart, eventIsEnd, eventOnlineStatusItem } from '@utils/zerone-event'
import { orderRegStatusItem, orderCheckinStatusItem } from '@utils/zerone-order'
import formatDate from '@utils/format-date'

export default {
  components: {
    DialogSession: () => import('@components/Dialog/Session'),
  },
  props: {
    // type: {
    //   type: String,
    //   default: 'physical',
    //   validator(value)
    //   {
    //     return [
    //       'online',
    //       'physical'
    //     ].includes(value)
    //   },
    // },
    live: {
      type: String,
      default: '',
    },
    detail: {
      type: String,
      default: '',
    },
    onlineType: {
      type: Boolean,
      default: false,
    },
    waitingBtn: {
      type: Boolean,
      default: false,
    },
    orderItem: {
      type: Object,
      default: () => {
        return {
          title: 'Modernweb 2021(單天實體統一報名)',
          alias: 'modernweb2021',
          dateType: 'single',
          type: 'physical', // 實體
          registrationType: 'impartial', // 統一
          seriesNum: 'IU767',
          regStatus: 'CONFIRMED',
          dateTimeRange: '2021/11/01(ㄧ) (10:00-14:40)',
          locationName: '張榮發國際會議中心',
          fullAddress: '臺北市中正區中山南路11號11樓',
          lat: 25.1234567,
          lng: 121.02564,
          qrcode: '5JIEkZF6sMSjftqbQbdqpODdSqONfIU9iEh6FvUx7T9WooCVUwnrK4cxYM9jz7MUywV2ehYDVHQCr1GrRsxbNMnFRDEcjzcueSVU6OzMZe74JL3lfMiRZTivP5q2d8pw',
          orders: [
            {
              orderNum: 'ZERONE21123457820',
              fullName: '傅惠貞',
              gender: 'male',
              email: 'turbo@hotmail.com.tw',
              phoneCode: '+886',
              phoneNumber: '0953053253',
              note: null,
            },
          ],
          sessions: [
            {
              date: '2021-11-01',
              sessions: [
                {
                  title: 'Digital and Application Innovation2',
                  startTime: '09:00',
                  endTime: '10:40',
                  checkinStatus: 'NOSHOW',
                  info: {
                    introtext: 'test',
                    personnels: [
                      {
                        name: 'Jordan',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                      {
                        name: 'Jerry',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                    ],
                    files: [],
                  },
                },
                {
                  title: 'Digital and Application Innovation',
                  startTime: '10:00',
                  endTime: '12:40',
                  checkinStatus: 'COMPLETED',
                  info: {
                    introtext: 'test',
                    personnels: [
                      {
                        name: 'Jordan',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                      {
                        name: 'Jerry',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                    ],
                    files: [],
                  },
                },
                {
                  title: '從 React 到 React Native 到 React Native Web 開發與設計須知',
                  startTime: '12:45',
                  endTime: '13:05',
                  checkinStatus: 'FORBIDDEN',
                  sessions: null,
                },
                {
                  title: '善用UX來提升UU：打造滿足新手和專家的UI',
                  startTime: '13:50',
                  endTime: '16:30',
                  checkinStatus: 'CHECKIN',
                  info: {
                    introtext: 'test',
                    personnels: [
                      {
                        name: 'Jordan',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                      {
                        name: 'Jerry',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                    ],
                    files: [],
                  },
                },
              ],
            },
          ],
          meal: [
            {
              date: '2021-11-01',
              value: '葷食餐點',
            },
          ],
          brands: [
            {
              alias: 'aimetis',
              logo: null,
            },
            {
              alias: 'f5',
              logo: null,
            },
          ],
        }
      },
    },
  },
  data() {
    return {
      activeSession: [0],
      isDialogSessionVisible: false,
      dialogSessionItem: {},
      multipleSelection: [],
    }
  },
  computed: {
    eventTime() {
      return eventSessionTimeTitle(this.orderItem.type, this.orderItem.categoryTitle)
    },
  },
  // created() {
  //   console.log('this.orderItem :>> ', this.orderItem)
  // },
  methods: {
    formatDate,
    openDialogSession(date, item) {
      const result = { ...item }
      delete result.info // 拿掉 info 這個 object , 因為要把 info 內的值跟 result 同層
      this.isDialogSessionVisible = true
      this.dialogSessionItem = {
        alias: this.orderItem.alias,
        seriesNum: this.orderItem.seriesNum,
        uuid: item.info.uuid,
        eventType: this.orderItem.type,
        categoryTitle: this.orderItem.categoryTitle,
        date: date,
        ...result,
        ...item.info,
        regStatus: this.orderItem.registrationType === 'impartial' ? this.orderItem.regStatus : result.regStatus,
      }
      // console.log(result) // 分場次？
      // console.log(this.orderItem.registrationType === 'impartial' ?  'a' : 'b')
    },
    dateTimeRange(item) {
      const timeRange = eventTimeRange({ ...item })
      return timeRange
    },
    goToLive(item) {
      this.$router.push({
        name: 'member-event-item-live',
        params: {
          sessionUuid: item.info.uuid,
        },
      })
    },
    sessionIsStart(date, time) {
      return eventIsStart(`${date} ${time}`)
    },
    sessionIsEnd(date, time) {
      return eventIsEnd(`${date} ${time}`)
    },
    sessionsOnlineStatus(date, session) {
      return eventOnlineStatusItem({
        alias: this.orderItem.alias,
        seriesNum: this.orderItem.seriesNum,
        uuid: session.info.uuid,
        date: date,
        startTime: session.startTime,
        endTime: session.endTime,
      })
    },
    sessionIsStartLinkOpenTime(onpenTime) {
      return eventIsStart(onpenTime)
    },
    statusItem(item) {
      return orderRegStatusItem(item)
    },
    checkInItem(date, time, status) {
      let checkinStatus = status
      // if(eventIsEnd(`${ date } ${ time }`) && status === 'CHECKIN') {
      //   checkinStatus = 'NOSHOW'
      // }

      return orderCheckinStatusItem(checkinStatus)
    },
  },
}
</script>

<template>
  <div :class="$style.orderSessionsList">
    <el-collapse v-model="activeSession" class="isStyleOrder">
      <el-collapse-item v-for="(item, $index) in orderItem.sessions" :key="$index" :title="formatDate(item.date, 'yyyy/MM/dd')" :name="$index" :disabled="orderItem.dateType === 'single'">
        <el-table :data="item.sessions" style="width: 100%" class="isStyleOrder d-lg-block d-none">
          <el-table-column :label="eventTime" width="300">
            <template slot-scope="scope">
              <span v-if="scope.row.regStatus === 'CANCELED'" style="opacity: 0.7">{{ dateTimeRange(scope.row) }}</span>
              <span v-else>{{ dateTimeRange(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="場次名稱">
            <template slot-scope="scope">
              <div v-if="scope.row.regStatus === 'CANCELED'">
                <BaseButton class="isStyleDark isText" style="white-space: initial; text-align: left" @click="openDialogSession(item.date, scope.row)">
                  <p style="text-decoration: line-through; opacity: 0.7">{{ scope.row.title }}</p>
                </BaseButton>
              </div>
              <div v-else-if="!scope.row.info">
                <span class="delete">{{ scope.row.title }}</span>
                (此活動已刪除)
              </div>
              <div v-else>
                <BaseButton class="isStyleDark isText" style="white-space: initial; text-align: left" @click="openDialogSession(item.date, scope.row)"> {{ scope.row.title }}</BaseButton>
                <template v-if="orderItem.regStatus === 'WAITING' && waitingBtn">
                  <el-tag class="isStyleInfo ml-4"> 候補 </el-tag>
                </template>
                <template v-else>
                  <template v-if="orderItem.dateType === 'multiple'">
                    <el-tag v-if="scope.row.regStatus === 'WAITING' && waitingBtn" class="isStyleInfo ml-4"> 候補 </el-tag>
                  </template>
                  <template v-else-if="orderItem.dateType === 'single'">
                    <el-tag v-if="orderItem.regStatus === 'WAITING' && waitingBtn" class="isStyleInfo ml-4"> 候補 </el-tag>
                  </template>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="waitingBtn" prop="title" label="" width="350">
            <template slot-scope="scope">
              <BaseButton class="isStylePrimary isOutline2 isFull isRadius isSmall" @click="openDialogSession(item.date, scope.row)">詳細資訊</BaseButton>
            </template>
          </el-table-column>
          <el-table-column v-if="detail === 'detail'" width="280">
            <template slot-scope="scope">
              <!-- 統一 -->
              <el-tag v-if="orderItem.registrationType === 'impartial'" class="" :class="statusItem(orderItem.regStatus).class">
                {{ statusItem(orderItem.regStatus).title }}
              </el-tag>
              <!-- 多天 -->
              <el-tag v-else class="" :class="statusItem(scope.row.regStatus).class">
                {{ statusItem(scope.row.regStatus).title }}
              </el-tag>
              <!-- 報到 -->
              <el-tag v-if="scope.row.regStatus === 'CONFIRMED' || orderItem.regStatus === 'CONFIRMED'" class="ml-2" :class="checkInItem(item.date, scope.row.endTime, scope.row.checkinStatus).class">
                {{ checkInItem(item.date, scope.row.endTime, scope.row.checkinStatus).title }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- 線上直播狀態 -->
          <template v-if="onlineType">
            <el-table-column v-slot="{ row }" label="直播狀態" width="150">
              <template v-if="row.info">
                <span :class="sessionsOnlineStatus(item.date, row).class">
                  {{ sessionsOnlineStatus(item.date, row).title }}
                </span>
              </template>
            </el-table-column>
            <el-table-column v-slot="{ row }" label="直播觀看" width="270">

              <template v-if="row.info && row.regStatus === 'CONFIRMED'">
                <template v-if="sessionIsStart(item.date, row.startTime) && sessionIsEnd(item.date, row.endTime)"> 
                  <div v-if="row.info.regEndDateExpired !== 0">已結束</div>
                  <BaseButton v-else class="isStylePrimary isOutline isSmaller" @click="goToLive(row)" style="min-width: 101px;"> 精彩回放 </BaseButton>
                </template>
                <div v-else-if="!sessionIsStartLinkOpenTime(row.info.linkOpeningTime)">
                  直播開放時間：
                  <br />{{ row.info.linkOpeningTime }}
                </div>
                <BaseButton v-else class="isStylePrimary isOutline isSmaller" @click="goToLive(row)" style="min-width: 101px;"> 前往觀看 </BaseButton>
                <div v-if="row.info.podcastLink">
                  <BaseButton class="isStylePrimary isOutline isSmaller" :href="row.info.podcastLink" target="_blank"> Podcast </BaseButton>
                </div>
              </template>
              <template v-if="row.info && row.regStatus === 'CANCELED'">
                報名取消，無法觀看
              </template>

            </el-table-column>
          </template>
        </el-table>
        <!-- mobile -->
        <div v-for="(sessionItem, index2) in item.sessions" :key="index2" class="list text-gray-6 d-lg-none d-block">
          <div class="d-flex justify-content-between item">
            <span class="d-md-inline d-none">{{ eventTime }}:</span>
            <div>
              <span v-if="sessionItem.regStatus === 'CANCELED'" class="text-gray-7" style="opacity: 0.7">{{ dateTimeRange(sessionItem) }}</span>
              <span v-else class="text-gray-7">{{ dateTimeRange(sessionItem) }}</span>
              <!-- 統一 審核 -->
              <el-tag v-if="orderItem.registrationType === 'impartial'" class="ml-2" :class="statusItem(orderItem.regStatus).class">
                {{ statusItem(orderItem.regStatus).title }}
              </el-tag>
              <el-tag v-else class="ml-2" :class="statusItem(sessionItem.regStatus).class">
                {{ statusItem(sessionItem.regStatus).title }}
              </el-tag>
              <!-- 報到 -->
              <el-tag
                v-if="sessionItem.regStatus === 'CONFIRMED' || orderItem.regStatus === 'CONFIRMED'"
                class="ml-2"
                :class="checkInItem(item.date, sessionItem.endTime, sessionItem.checkinStatus).class"
              >
                {{ checkInItem(item.date, sessionItem.endTime, sessionItem.checkinStatus).title }}
              </el-tag>
            </div>
            <!-- 直播狀態 -->
            <template v-if="onlineType && (sessionItem.regStatus === 'CONFIRMED' || orderItem.regStatus === 'CONFIRMED')">
              <template v-if="!!sessionItem.info">
                <div class="text-right d-md-none">
                  <span :class="sessionsOnlineStatus(item.date, sessionItem).class">
                    {{ sessionsOnlineStatus(item.date, sessionItem).title }}
                  </span>
                </div>
              </template>
            </template>
          </div>
          <div class="d-flex justify-content-sm-between item">
            <!-- <span>場次名稱:</span> -->
            <div v-if="sessionItem.regStatus === 'CANCELED'" class="orderSessionsList__title color-gray-7" @click="openDialogSession(item.date, sessionItem)">
              <p style="text-decoration: line-through; opacity: 0.7">{{ sessionItem.title }}</p>
            </div>
            <div v-else-if="!item.sessions">
              <span class="delete"> {{ sessionItem.title }}/1 </span>
              (此活動已刪除)
            </div>
            <div v-else class="orderSessionsList__title color-gray-7" @click="openDialogSession(item.date, sessionItem)"> {{ sessionItem.title }} </div>
          </div>
          <!-- 直播狀態 -->
          <template v-if="onlineType">
            <template v-if="!!sessionItem.info">
              <div v-if="sessionItem.regStatus === 'CONFIRMED' && orderItem.regStatus === 'CONFIRMED'" class="text-md-right">
                <span class="d-md-inline d-none" :class="sessionsOnlineStatus(item.date, sessionItem).class">
                  {{ sessionsOnlineStatus(item.date, sessionItem).title }}
                </span>
                <template v-if="sessionIsStart(item.date, sessionItem.startTime) && sessionIsEnd(item.date, sessionItem.endTime)"> 
                  <span v-if="sessionItem.info.regEndDateExpired !== 0">已結束</span>
                  <BaseButton v-else class="isStylePrimary isTextUnderline" @click="goToLive(sessionItem)"> 精彩回放 </BaseButton>
                 </template>
                <div v-else-if="!sessionIsStartLinkOpenTime(sessionItem.info.linkOpeningTime)">
                  直播開放時間：
                  <br />{{ sessionItem.info.linkOpeningTime }}
                </div>
                <BaseButton v-else class="isStylePrimary isTextUnderline" @click="goToLive(sessionItem)"> 前往觀看 </BaseButton>
              </div>
              <div v-else class="text-md-right">
                {{ orderItem.registrationType === 'impartial' ? statusItem(orderItem.regStatus).onlineTitle : statusItem(sessionItem.regStatus).onlineTitle }}
              </div>

            </template>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
    <DialogSession :session-item="dialogSessionItem" :visible.sync="isDialogSessionVisible" />
  </div>
</template>
<style lang="scss" module>
.orderSessionsList {
  :global {
    .orderSessionsList {
      &__title {
        transition: 0.3s;
        text-decoration: none;
        cursor: pointer;
        @include max-md {
          margin-bottom: 0.875rem;
        }
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
